import { defineComponent, PropType } from 'vue';
import { ButtonType } from 'element-plus/lib/components/button/src/button';
import { Download } from '@element-plus/icons-vue';

const icons = {
  Download,
};

export default defineComponent({
  name: 'DownloadActions',

  components: {
    Download,
  },

  props: {
    type: {
      type: String as PropType<ButtonType>,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['get-report'],

  setup(_, { emit }) {
    const getReport = (isTimestampRequired: boolean): void => {
      emit('get-report', isTimestampRequired);
    };

    return {
      icons,
      getReport,
    };
  },
});
